import { useMutation, UseMutationOptions } from 'react-query';
import { AxiosError } from "axios";
import { Dispatch } from 'react';

import request from "common/request";

type UploadPhotoMutationVariable = {
  filename?: FormData;
  setProgress:Dispatch<number>;
  id: string
};

export const usePostUploadFreeKit = ( 
  options?: UseMutationOptions<any, AxiosError, UploadPhotoMutationVariable>
) => { 
  return useMutation<any, AxiosError, UploadPhotoMutationVariable>(
    async ({ filename, setProgress, id }) => {
      try {
        //@ts-ignore
        for (let pair of filename.entries()) {
          console.log('sending', pair[0] + ': ' + pair[1]);
        }
        const response = await request.post(`/photo/free/${id}`, filename,
        {
          headers:{
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress:(progressEvent) => {
            const loaded = progressEvent.loaded;
            const total: number |undefined = progressEvent.total ?? 0;
            const percentage = Math.round((loaded / total) * 100);
            setProgress(percentage); 
          },
        },
      );
        return response
      } catch(e){
        //@ts-ignore
        const result = e.response;
        if (result.status === 401) {
          window.location.href = '/onboarding/1/freekit'
        }
        return result
      } 
    },
    {
      ...options
    }
  )
};

export default usePostUploadFreeKit;